module.exports = {
  ...require('./masterPage'),
  ...require('./Product'),
  ...require('./previewModal'),
  ...require('./productSupportPage'),
};
